import { useState } from 'react';

import Item from './Item';

const faqs = [
  {
    id: 1,
    title: 'How does the wallet work?',
    content:
      'The wallet is 100% self-custodial and runs on Binance Smart Chain (BSC). This means only you control your funds. The platform has no access and cannot recover funds if you make a mistake.',
  },
  {
    id: 2,
    title: 'What token can I deposit directly?',
    content:
      'You can only deposit native USDT on BSC. ⚠️ Sending any other token or using a different network will result in a permanent loss of funds. There is nothing we can do to recover them.',
  },
  {
    id: 3,
    title: 'Can I deposit from other networks or assets?',
    content:
      'Yes. You can deposit from other chains and assets using DeBridge. Follow the instructions in the app to avoid mistakes.',
  },
  {
    id: 4,
    title: 'Are deposits instant?',
    content:
      'Most deposits are instant, but may experience delays depending on network congestion. You can check the status via a block explorer.',
  },
  {
    id: 5,
    title: 'How long does it take to top up the card after depositing?',
    content:
      "Card top-ups are usually instant, but they may take up to 60 to 120 minutes in some cases. Please don't retry immediately — wait for the transaction to be processed.",
  },
  {
    id: 6,
    title: 'What happens if I send the wrong funds to my wallet?',
    content:
      "⚠️ That's your responsibility. As the wallet is self-custodial, no one can recover lost or incorrect transfers. Always double-check before sending.",
  },
  {
    id: 7,
    title: 'Where can I access or export my private key?',
    content:
      'You can view and export your private key from your profile in the app. Store it safely if you plan to manage your wallet externally.',
  },
  {
    id: 8,
    title: 'How do the card plans work?',
    content:
      'Each card comes with an annual plan, including specific limits and fees. Make sure to review the plan details before activating.',
  },
  {
    id: 9,
    title: 'How long do refunds from purchases take?',
    content:
      "If you receive a refund for a card purchase, it may take between 7 and 45 days to appear. This depends entirely on the issuing bank's country and processing times. It's not something we can control.",
  },
  {
    id: 10,
    title: 'Are there currency conversion fees?',
    content:
      "Yes. If you pay in a currency different from your card's base currency, a foreign exchange fee between 1% and 2% will apply. 💡 Tip: When paying at a store or online, if the terminal gives you the option, always choose to pay in the local currency of the country you're in — this can help reduce the FX fee depending on the establishment.",
  },
  {
    id: 11,
    title: 'What is the fee per transaction?',
    content:
      'Each card transaction includes a fixed authorization fee of $0.30.',
  },
  {
    id: 12,
    title: 'What happens if I get too many declined transactions?',
    content:
      "If more than 20% of your transactions are declined, the issuing bank may freeze your card for security reasons. ✅ Always make sure you have sufficient balance before attempting a payment. ❌ If a transaction is declined, don't try it repeatedly, as each failed attempt is counted and may trigger the bank's risk controls.",
  },
  {
    id: 13,
    title: 'Can I use my virtual card at ATMs or financial platforms?',
    content:
      'No. Virtual cards are not compatible with ATMs. Attempting to use them at an ATM may trigger fraud alerts and result in the card being automatically blocked. Additionally, the card does not work on financial-related services such as banks, exchanges, gambling platforms, or casinos. These restrictions are enforced by the card issuer and cannot be bypassed. To ensure uninterrupted use, always follow the card usage guidelines and avoid high-risk merchants.',
  },
];

const Faq = () => {
  const [activeItemId, setActiveItemId] = useState<number | null>(null);

  const handleItemClick = (itemId: number) => {
    setActiveItemId(activeItemId === itemId ? null : itemId);
  };
  return (
    <div className=''>
      <h2 className='mb-10 text-center text-h3 max-lg:mb-6 max-lg:text-h4 max-md:text-left'>
        Frequently asked questions
      </h2>

      <div className=''>
        {faqs?.map((item) => (
          <Item
            value={item}
            isActive={activeItemId === item.id}
            onClick={() => handleItemClick(item.id)}
            key={item.id}
          />
        ))}
      </div>
    </div>
  );
};

export default Faq;
